import { SmsProviderConstants } from "../constants/smsprovider.constants";

const SmsProviderReducer = (state, action) => {
  switch (action.type) {
    case SmsProviderConstants.FETCH_SMS_PROVIDER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case SmsProviderConstants.FETCH_SMS_PROVIDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        smsProviders: action.payload.data,
        paging: action.payload.paging,
      };
    case SmsProviderConstants.FETCH_SMS_PROVIDER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case SmsProviderConstants.SMS_PROVIDER_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case SmsProviderConstants.SMS_PROVIDER_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        smsProviderSearchResults: action.payload,
      };
    case SmsProviderConstants.SMS_PROVIDER_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case SmsProviderConstants.SMS_PROVIDER_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case SmsProviderConstants.SMS_PROVIDER_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        smsProviderAutoSearchResults: action.payload,
      };
    case SmsProviderConstants.SMS_PROVIDER_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case SmsProviderConstants.ADD_SMS_PROVIDER_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case SmsProviderConstants.ADD_SMS_PROVIDER_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case SmsProviderConstants.ADD_SMS_PROVIDER_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case SmsProviderConstants.GET_SMS_PROVIDER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case SmsProviderConstants.GET_SMS_PROVIDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        smsProvider: action.payload,
      };
    case SmsProviderConstants.GET_SMS_PROVIDER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case SmsProviderConstants.UPDATE_SMS_PROVIDER_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case SmsProviderConstants.UPDATE_SMS_PROVIDER_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        smsProvider: action.payload,
      };
    case SmsProviderConstants.UPDATE_SMS_PROVIDER_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case SmsProviderConstants.DOWNLOAD_SMS_PROVIDER_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case SmsProviderConstants.DOWNLOAD_SMS_PROVIDER_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case SmsProviderConstants.DOWNLOAD_SMS_PROVIDER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case SmsProviderConstants.UPLOAD_SMS_PROVIDER_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case SmsProviderConstants.UPLOAD_SMS_PROVIDER_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case SmsProviderConstants.UPLOAD_SMS_PROVIDER_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };

    default:
      return state;
  }
};

export default SmsProviderReducer;
